// extracted by mini-css-extract-plugin
export default {"container":"AC-z","dimension":"BC-z","dimensionLabels":"CC-z"};